import { diffWords } from 'diff';

export function generateDiff(oldStr: string, newStr: string): string {
  const diff = diffWords(oldStr, newStr);
  const html = diff.map((part) => {
    if (part.added)
      return '<ins class="decoration-marker-change underline-offset-2">' + part.value + '</ins>';
    else if (part.removed)
      return '<del class="hidden decoration-marker-change">' + part.value + '</del>';
    else return part.value;
  });
  return html.join('');
}
